export default "__VITE_ASSET__I9VBJ6hV__"